import { render, staticRenderFns } from "./EmphasizedInfoBlock.vue?vue&type=template&id=c094b8e0&"
import script from "./EmphasizedInfoBlock.vue?vue&type=script&lang=js&"
export * from "./EmphasizedInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./EmphasizedInfoBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports